import DetailsForm from './DetailsFormContainer';

export default DetailsForm;
